import React from 'react';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon-new.svg';
import { EMPTY_FUNCTION } from 'Utils/constants';

const ToolTipWithIcon = props => {
  const {
    className = '',
    children,
    Icon = '',
    offset: { right = 0, left = 0 } = {},
    callback = EMPTY_FUNCTION,
  } = props;
  const toolTipRef = React.useRef();

  const calculatePosition = () => {
    let offsetPosition = 0;
    if (toolTipRef.current) {
      // const iconWrap = toolTipRef.current.parentElement?.parentElement?.querySelector(
      //   '.icon-wrap',
      // );
      const elementAttributes = toolTipRef.current.getBoundingClientRect();
      // eslint-disable-next-line no-undef
      const screenWidth = window.innerWidth;

      if (elementAttributes.right > screenWidth - (right + 5))
        offsetPosition = screenWidth - (right + 5) - elementAttributes.right;
      else if (elementAttributes.left < left + 5)
        offsetPosition = left + 5 - elementAttributes.left;
      if (offsetPosition !== 0) {
        toolTipRef.current.style.transform = `translateX(calc(-50% ${
          offsetPosition > 0 ? '+' : '-'
        } ${Math.abs(offsetPosition)}px))`;
        const sharpPoint = toolTipRef.current.querySelector('.sharpPoint');
        if (sharpPoint)
          sharpPoint.style.transform = `translateX(calc(-50% ${
            offsetPosition > 0 ? '-' : '+'
          } ${Math.abs(offsetPosition)}px)) rotate(-45deg)`;
      }

      callback();
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
    <div
      className="toolTipParentWrap new-tooltip info-with-icon"
      onMouseEnter={calculatePosition}
    >
      {
        <div className="icon-wrap">
          {Icon || <InfoIcon className="info-icon" />}
        </div>
      }
      <div className="tooltip-box-wrapper">
        <div className={`toolTipWrap ${className}`} ref={toolTipRef}>
          <div className="toolTipTextWrap">{children}</div>
          <span className="sharpPoint" />
        </div>
      </div>
    </div>
  );
};

export default ToolTipWithIcon;
